
import { UserHeader } from "@/components/layout/UserHeader";
import { VoucherContainer } from "@/components/vouchers/VoucherContainer";
import { LoadingScreen } from "@/components/common/LoadingScreen";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function Index() {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-black text-[#FFFCF3]">
      <UserHeader />
      <VoucherContainer />
    </div>
  );
}
